import React from "react";
import { useTranslation } from "react-i18next";
import { useLocalize } from "hooks";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import Logo from "assets/images/svg/dexef_logo_nav.svg";
import Language from "assets/images/svg/language.svg";
import { t } from "i18next";
import { usePreregisterData } from "pages/registration/registration.service";

function NavigatorNavbar() {
  const { i18n } = useTranslation();
  const { languages } = useLocalize();
  const { pathname } = useLocation();
  const { setPreregisterData } = usePreregisterData();

  return (
    <Navbar className="customerNavbar" expand="lg" fixed="top">
      <div className="container-fluid">
        <a className="logo" href="https://dexef.com">
          <img src={Logo} alt="Dexef Logo" />
        </a>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <NavLink className="nav-link" to="/download-center">
              {t("home:navbar.downloadCenter") as string}
            </NavLink>
            <NavLink className="nav-link" to="/contact-us">
              {t("home:navbar.contactUs") as string}
            </NavLink>
          </Nav>

          <Nav className="mr-auto">
            <NavDropdown title={<img src={Language} alt="IconProfile" />} id="basic-nav-dropdown" className="language">
              {languages.map((lang) => (
                <NavDropdown.Item key={lang.code} role={lang.code} onClick={() => i18n.changeLanguage(lang.code)}>
                  {lang.name}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
            {pathname !== "/login" && (
              <Link to="/login" className="btn-White">
                {" "}
                {t("home:login") as string}
              </Link>
            )}
            {pathname !== "/register" && pathname === "/login" && (
              <Link
                to="/temp-register"
                className="btn-blue"
                onClick={() => {
                  setPreregisterData(undefined);
                }}
              >
                {" "}
                {t("home:sign-up") as string}
              </Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}

export default NavigatorNavbar;
